import OpenSeadragon from "openseadragon";

const overlays = [
  {
    id: 'marker-island',
    x: 0.24,
    y: 0.09,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  {
    id: 'marker-mine',
    x: 0.28,
    y: 0.275,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  {
    id: 'marker-horse',
    x: 0.10,
    y: 0.40,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Einstiegsvideo
  {
    id: 'marker-startvideo',
    x: 0.21,
    y: 0.66,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
//Baumhaus
  {
    id: 'marker-treehouse',
    x: 0.31,
    y: 0.47,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Zirkuszelt
  {
    id: 'marker-circus',
    x: 0.36,
    y: 0.32,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Geisterdorf
  {
    id: 'marker-ghosttown',
    x: 0.48,
    y: 0.25,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Crossrad
  {
    id: 'marker-crossbicycle',
    x: 0.46,
    y: 0.19,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Grubenranddorf
  {
    id: 'marker-wholevillage',
    x: 0.45,
    y: 0.17,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Stromnetze
  {
    id: 'marker-powerlines',
    x: 0.43,
    y: 0.12,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Menschen am Fuß des Baggers
  {
    id: 'marker-peopleatexcavator',
    x: 0.48,
    y: 0.32,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Solarpanel
  {
    id: 'marker-solarroof',
    x: 0.55,
    y: 0.34,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Tagebau
  {
    id: 'marker-surfacemine',
    x: 0.54,
    y: 0.25,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Spinne
  {
    id: 'marker-spider',
    x: 0.62,
    y: 0.25,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Zuckerrübe
  {
    id: 'marker-sugarbeet',
    x: 0.70,
    y: 0.26,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  ///Fledermaus
  {
    id: 'marker-bat',
    x: 0.62,
    y: 0.52,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Faultier
  {
    id: 'marker-lazybone',
    x: 0.68,
    y: 0.52,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Redline
  {
    id: 'marker-redline',
    x: 0.75,
    y: 0.30,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Queer we go
  {
    id: 'marker-queerwego',
    x: 0.85,
    y: 0.26,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Permafrostboden
  {
    id: 'marker-permasoile',
    x: 0.88,
    y: 0.09,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //co2
  {
    id: 'marker-co2',
    x: 0.75,
    y: 0.10,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  {
    id: 'marker-stakeholders',
    x: 0.75,
    y: 0.20,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Muschel
  {
    id: 'marker-shell',
    x: 0.90,
    y: 0.65,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },
  //Rwe ARbeiter
  {
    id: 'marker-rweworker',
    x: 0.40,
    y: 0.66,
    width: 0.01,
    height: 0.01,
    className: 'marker'
  },

];

export default function startDeepZoomImage() {
  //console.log('Init deep zoom image...');

  var viewer = OpenSeadragon({
    debugMode: false,
    debugGridColor: "[black]",
    showHomeControl: false,
    visibilityRatio: 1,
    constrainDuringPan: false,
    id: "zoom-image-canvas",
    prefixUrl: "/app/uploads/wimmel/wimmelbild_files",
    tileSources: "/app/uploads/wimmel/wimmelbild.dzi",
    overlays: overlays,
    showNavigationControl: true,
    showZoomControl: true,
    showFullPageControl: false,
    zoomInButton:  "btn-zoom-in",
    zoomOutButton: "btn-zoom-out",
  });


  $("#btn-full-screen").on('click', function () {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  })

  overlays.forEach(function (overlay) {
    new OpenSeadragon.MouseTracker({
      element: overlay.id,
      clickHandler: function (e) {
        const {id} = e.originalEvent.target;
        const infoId = "#info-" + id.replace("marker-", "");
        $('.info').hide();
        $(".infos").animate({ right: 0 }, 200, function(){
          //$('#zoom-image-canvas').animate({width: "65%"}, 100);
          $(infoId).show();
        });
      }
    });
  })

  $(".info-close-button").on('click', function(){
    //$('#zoom-image-canvas').animate({width: "100%"},100);
    $(".infos").animate({ right: "-35%" }, 200, function(){
      $('.info').hide();
    });
  })

}



// WEBPACK FOOTER //
// ./scripts/deepzoom-exercise.js